module.exports = "https://coursera_assets.s3.amazonaws.com/images/c203a9f27c024f1773a4311a89b47a44.png";